/**
 * API Endpoints Configuration
 */

export const API_ENDPOINTS = {
  // System Parameters
  SYSTEM_PARAMETERS: "/v1/bdg-sys-parameters",

  // Messages
  MESSAGES: "/v1/bdg-messages",

  // Roles
  ROLES: "/v1/bdg-roles",
  ORG_ROLES: "/v1/bdg-org-roles",

  // Units
  UNITS: "/v1/bdg-units",

  // Org Types
  ORG_TYPES: "/v1/bdg-org-types",

  // Org Units
  ORG_UNITS: "/v1/bdg-org-units",
  ORG_UNIT_RELATIONS: "/v1/bdg-org-unit-relations",

  // Users by Org Unit
  USERS_BY_ORG_UNIT: "/v1/users/org-unit",
  USERS_ASSIGNED_BY_ORG_UNIT: "/v1/users/org-unit/assigned",

  // User Search
  USER_SEARCH: "/v1/users/user-search",
  GET_USER: "/v1/users/getuser",

  // Role Assignments
  ROLE_ASSIGNMENTS: "/v1/bdg-role-assignments",

  // Headcount
  ORG_HEADCOUNTS: "/v1/bdg-org-head-counts",

  // Org Templates
  ORG_TEMPLATES: "/v1/bdg-org-templates",

  // Budget Templates
  BUDGET_TEMPLATES: "/v1/bdg-templates",

  // Budget Template Items
  BUDGET_TEMPLATE_ITEMS: "/v1/bdg-template-items",

  // Currencies
  CURRENCIES: "/v1/bdg-currencies",

  // Budget Terms
  BUDGET_TERMS: "/v1/bdg-budget-terms",

  // Budget Items
  BUDGET_ITEMS: "/v1/bdg-items",

  // Budget Item Rules
  BUDGET_ITEM_RULES: "/v1/bdg-item-rules",

  // Rule Methods
  RULE_METHODS: "/v1/bdg-rule-methods",

  // Rule Assign Methods
  RULE_ORG_TYPE_ASSIGN_METHODS: "/v1/bdg-item-rules/org-type-assign-methods",
  RULE_ORG_ID_ASSIGN_METHODS: "/v1/bdg-item-rules/org-id-assign-methods",

  // Material Items
  MATERIAL_ITEMS: "/v1/bdg-material-items",

  // Rule Material Assignments
  RULE_MTL_ASSIGNMENTS: "/v1/bdg-item-rule-mtl-assign",
  RULE_MTL_ASSIGNMENTS_BULK: "/v1/bdg-item-rule-mtl-assign/bulk",

  // Rule Org Assignments
  RULE_ORG_ASSIGNMENTS: "/v1/bdg-item-rule-org-assign",
  RULE_ORG_ASSIGNMENTS_BULK: "/v1/bdg-item-rule-org-assign/bulk",

  // Budget Plans
  BUDGET_PLANS_MY_ORGS: "/v1/bdg-plans/my-orgs",
  BUDGET_PLANS_ORG_PLANS: "/v1/bdg-plans/org-plans",
  BUDGET_PLANS_TREE_SEARCH: "/v1/bdg-plans/budget-tree-search",
  BUDGET_PLANS_LINE_RULES_BY_LINE: "/v1/bdg-plans/line-rules-by-line",
  BUDGET_PLANS_LINE_RULE_MATERIALS: "/v1/bdg-plans/line-rule-materials",
  BUDGET_PLANS_LINE_DETAIL_CREATE: "/v1/bdg-plans/bdg-line-detail-create",
  BUDGET_PLANS_GET_LINE_DETAILS: "/v1/bdg-plans/bdg-get-line-details",
  BUDGET_PLANS_GET_LINE_DETAIL_FOR_EDIT: "/v1/bdg-plans/bdg-get-line-detail-for-edit",
  BUDGET_PLANS_GET_LINE_DETAIL_FOR_VIEW: "/v1/bdg-plans/bdg-get-line-detail-for-view",
  BUDGET_PLANS_LINE_UPDATE: "/v1/bdg-plans/bdg-line-update",
  BUDGET_PLANS_LINE_DETAIL_DELETE: "/v1/bdg-plans/bdg-line-detail-delete",
  BUDGET_PLANS_CREATE_DRAFT_FROM_TEMPLATE: "/v1/bdg-plans/create-draft-from-template",
  BUDGET_PLANS_RECREATE_DRAFT_FROM_TEMPLATE: "/v1/bdg-plans/recreate-draft-from-template",
  BUDGET_PLANS_CONVERSION_RATES: "/v1/bdg-plans/bdg-conversion-rates",
  BUDGET_PLANS_TERM_MONTHS: "/v1/bdg-plans/bdg-term_months",
  BUDGET_PLAN_LOV_ITEMS: "/v1/bdg-plan-lov/items",
  BUDGET_PLAN_LOV_STATUSES: "/v1/bdg-plan-lov/statuses",
  BUDGET_PLAN_LOV_STATUSES_ALL: "/v1/bdg-plan-lov/statuses-all",
  BUDGET_PLAN_LOV_BUDGET_TERMS: "/v1/bdg-plan-lov/budget-terms",
  BUDGET_PLANS_TRACKING: "/v1/bdg-plans/tracking",
  BUDGET_REPORTS_PLAN_TRACKING_DETAIL: "/v1/bdg-reports/bdg-plan-tracking-detail",
  BUDGET_REPORTS_PLAN_TRACKING: "/v1/bdg-reports/bdg-plan-tracking",
  BUDGET_REPORTS_BUDGET_REPORT: "/v1/bdg-reports/bdg-budget-report",
  BUDGET_APPROVE_ORG_PLANS: "/v1/bdg-plans/org-plans-proc",
  BUDGET_APPROVE_PLAN_DETAILS: "/v1/bdg-plan-approve/plan-details",
  BUDGET_APPROVE_TARGET_STATUSES: "/v1/bdg-plan-approve/approval-target-statuses",
  BUDGET_APPROVE_ACTION_LOGS: "/v1/bdg-plan-approve/action-logs",
  BUDGET_APPROVE_PLAN_SUBMIT: "/v1/bdg-plan-approve/plan-submit",
  BUDGET_APPROVE_PLAN_APPROVAL_DECISION_SAVE: "/v1/bdg-plan-approve/plan-approval-decision-save",
  BUDGET_APPROVE_PLAN_APPROVAL_DECISION_FINALIZE: "/v1/bdg-plan-approve/plan-approval-decision-finalize",

  // Dashboard
  BUDGET_DASHBOARD_PLANS: "/v1/bdg-dashboard/plans",
  BUDGET_DASHBOARD_CUSTOMER_INSIGHT: "/v1/bdg-dashboard/customer-insight",
  BUDGET_DASHBOARD_PLANNED_BUDGET_OVER_TIME: "/v1/bdg-dashboard/planned-budget-over-time",
  BUDGET_DASHBOARD_GROUP_STATUS_BREAKDOWN: "/v1/bdg-dashboard/group-status-breakdown",
  BUDGET_DASHBOARD_PLAN_PLANNED_VS_APPROVED_BY_MONTH: "/v1/bdg-dashboard/plan-planned-vs-approved-by-month",
  BUDGET_DASHBOARD_RATING: "/v1/bdg-dashboard/rating",

  // Auth
  AUTH_SIGN_IN: "/auth/sign-in",
  AUTH_REGISTER: "/auth/register",

} as const

export type ApiEndpoint = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS]
